import { gql } from '@apollo/client';

export const COURSE_DETAIL = gql`
  query Course($courseId: ID!) {
    course(id: $courseId) {
      id
      title
      description
      thumbnail
      videoUrl
      attachment
      presentationFile
      duration
      kind
      category
      createdAt
      test {
        id
        required
        passScore
        questions {
          id
          prompt
          type
          options {
            id
            text
          }
          order
          points
        }
      }
    }
  }
`;

export const COURSE_WATCH_PROGRESS = gql`
  query CourseWatchProgress($courseId: ID!) {
    courseWatchProgress(courseId: $courseId) {
      id
      position
      duration
      percent
      completed
      lastWatchedAt
    }
  }
`;

export const CUSTOMER_COURSE_TEST_ATTEMPTS = gql`
  query CustomerCourseTestAttempts($courseId: ID!) {
    customerCourseTestAttempts(courseId: $courseId) {
      id
      score
      totalPoints
      passed
      attemptedAt
    }
  }
`;

export const CONTINUE_WATCHING = gql`
  query ContinueWatching($limit: Int) {
    continueWatching(limit: $limit) {
      id
      position
      duration
      percent
      completed
      lastWatchedAt
      course {
        id
        title
        thumbnail
        videoUrl
        duration
        kind
        myStatus {
          status
          percent
          lastAttemptScorePercent
          lastAttemptPassed
          attemptsCount
        }
      }
    }
  }
`;
